import React from 'react'

import { Outlet, ScrollRestoration } from 'react-router-dom'

import { KeyboardProvider } from '@/contexts/KeyboardContext'
import { StationModalProvider } from '@/contexts/StationModalContext'
import { ActiveSessionProvider } from '@/contexts/ActiveSessionContext'

import AppUrlListener from '@/components/Router/AppUrlListener'
import ErrorHandler from '@/components/Router/ErrorHandler'
import BiometricLockGuard from '@/components/Router/BiometricLockGuard'
import { ActiveSessionBanner } from '@/components/ActiveSessionBanner'
import DevBanner from '@/components/DevBanner'

const Root: React.FC = () => {
  return (
    <ActiveSessionProvider>
      <StationModalProvider>
        <KeyboardProvider>
          <DevBanner />
          <ScrollRestoration />
          <BiometricLockGuard />
          <Outlet />
          <AppUrlListener />
          <ErrorHandler />
          <ActiveSessionBanner />
        </KeyboardProvider>
      </StationModalProvider>
    </ActiveSessionProvider>
  )
}

export default Root
